<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login - Acesso UFJF</v-toolbar-title>
                <div class="flex-grow-1"/>
              </v-toolbar>
              <v-card-text>
                <v-form
                  novalidate
                  @submit.prevent="handleSubmit"
                >
                  <v-text-field
                    v-model="$v.username.$model"
                    label="Login"
                    name="username"
                    prepend-icon="mdi-account"
                    type="text"
                    :error-messages="validationLabel('username', $v)"
                  />
                  <v-text-field
                    id="password"
                    v-model="$v.password.$model"
                    label="Senha"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :error-messages="validationLabel('password', $v)"
                    @keyup.enter="handleSubmit"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"/>
                <v-btn
                  :loading="loading"
                  :disabled="$v.$invalid"
                  color="primary"
                  @click="handleSubmit"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
    import {required, minLength} from 'vuelidate/lib/validators'
    import getLabels from '../utils/validators'
    import {
        mapState,
    } from 'vuex'

    export default {
        props: {
            source: String,
        },
        data: () => ({
            drawer: null,
            username: '',
            password: '',
        }),
        computed: {
            validationLabel() {
                return getLabels
            },
            ...mapState('app', ['loading']),

        },
        methods: {
            handleSubmit() {
                if (!this.$v.$invalid) {
                    this.$store.dispatch('account/LOGIN', {
                        username: this.username,
                        password: this.password,
                    })
                }
            },
        },
        validations: {
            username: {
                required,
                minLength: minLength(4),
            },
            password: {
                required,
                minLength: minLength(4),
            },
        },
    }
</script>
